import { isDraftSaveAction } from '../../../Draft'
import { FormModalConfirmation } from '../../../Form'
import { RequestDraftCloseActionSelectModal } from '../../RequestDraftCloseActionSelectModal'
import { useRequestDraft } from '../useRequestDraft'

export function useRequestCreationFormConfirmation({
  getDraftPayload,
  useDraft = useRequestDraft,
  onClose,
  onSubmitConfirm,
}) {
  const { draftId, setDraft } = useDraft()

  function handleSubmitConfirm(values, files, action) {
    const nextDraft = isDraftSaveAction(action)
      ? getDraftPayload
        ? getDraftPayload(values)
        : values
      : null

    setDraft(nextDraft, 0)

    onSubmitConfirm?.(values, files, action)
    onClose()
  }

  return {
    Confirmation: draftId
      ? RequestDraftCloseActionSelectModal
      : FormModalConfirmation,
    handleSubmitConfirm,
  }
}
